module.exports = __webpack_public_path__ + "f3cd29b7cb26dc9497aa6bc464412a5f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/8_G2.mp3
// module id = 83
// module chunks = 0